import OneSignal from "react-onesignal";
import clientIdStorage from "./storage";

export const runOneSignal = async () => {
  let shouldContinue = false;
  shouldContinue = import.meta.env.PROD || import.meta.env.VITE_SET_ONESIGNAL;

  if (!shouldContinue) {
    return;
  }

  try {
    await OneSignal.init({
      appId: import.meta.env.VITE_ONESIGNAL_APP_ID as string,
      allowLocalhostAsSecureOrigin: false,
      // promptOptions: {
      //   actionMessage:
      //     "Voulez-vous recevoir des notifications d'aide à la décision ?",
      //   cancelButton: "Annuler",
      //   acceptButton: "Autoriser",
      // },
      // welcomeNotification: {
      //   disable: true,
      // },
    });
    void OneSignal.Slidedown.promptPush();
  } catch (error) {
    console.warn(error);
  }

  const clientId = clientIdStorage.get();

  const tags = {
    client: clientId,
  };

  OneSignal.User.addTags(tags);
};
